import React, { useEffect } from "react";

// import * as DateUtil from "utils/dateUtil";

import { Grid, Card, Button, Alert, IconButton, Collapse, RadioGroup, FormControlLabel, Radio, FormControl, FormLabel } from "@mui/material";
import { Close as CloseIcon, AddCircle as AddCircleIcon } from "components/icons";
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';


import { blue, green } from '@mui/material/colors';

import "app/components/leave-plans/LeavePlanForMemberView.css";
import { checkUserHasMemberRole, readSessionCurrentMember } from "app/services/app.state.service";
import { getDateInFormat } from "utils/dateUtil";
import * as AppConstants from "AppConstants";
import { isEmpty } from "utils/validationUtil";
import { addLeavePlanToBackend } from "app/services/member.service";
import { handleAxiosError } from "app/services/app.error.handler";
import { validateLeavePlanObject } from "utils/leavePlanValidationUtil";

export const AddLeavePlan = () => {
    const [memberId, setMemberId] = React.useState();
    const [leavePlanStartDate, setLeavePlanStartDate] = React.useState(new Date());
    const [leavePlanEndDate, setLeavePlanEndDate] = React.useState(new Date());
    const [leavePlanReason, setLeavePlanReason] = React.useState("");
    const [leaveDuration, setLeaveDuration] = React.useState(AppConstants.DEFAULT_LEAVE_DURATION);
    const [message, setMessage] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState("info"); // "error" or "warning" or "info" or "success"

    useEffect(() =>  {
        // if valid login; and user role is member; then get memberId from the stored loggedInUser object
        if(!checkUserHasMemberRole()) return;

        var member = readSessionCurrentMember();

        if(isEmpty(member)) return;

        setMemberId(member.id);

    }, []);

    function disableWeekends(date) {
        return new Date(date).getDay() === 0 || new Date(date).getDay() === 6;
        // return false;
    }
      
    const clearAddLeavPlanForm = () => {
        setLeavePlanReason("");
        document.getElementById("addLeavePlanDescription").value = "";
    }

    const setErrorAction = (errorMessage) => {
        setMessage(errorMessage);
        setOpen(true);
        setSeverity("error")
    }

    const setSuccessAction = (message) => {
        setMessage(message);
        setOpen(true);
        setSeverity("success")
    }

    // Half-day is only valid for a single-day leave; multi-day leave is always FULL_DAY.
    const isMultiDayLeave = getDateInFormat(leavePlanStartDate) !== getDateInFormat(leavePlanEndDate);

    const addLeavePlanClickHandler = async () => {
        const leavePlanBody = {
            memberId: memberId,
            reason: leavePlanReason,
            startDate: getDateInFormat(leavePlanStartDate),
            endDate: getDateInFormat(leavePlanEndDate),
            status: AppConstants.DEFAULT_LEAVE_PLAN_STATUS,
            type: AppConstants.DEFAULT_LEAVE_PLAN_TYPE,
            leaveDuration: isMultiDayLeave ? AppConstants.DEFAULT_LEAVE_DURATION : leaveDuration,
        };
        if(!validateLeavePlanObject(leavePlanBody)) {
            setErrorAction("Invalid Input: Leave plan end date should be equal to or after start date | description can not be empty");
            return;
        }

        await addLeavePlanToBackend(leavePlanBody)
        .then(data => {
            setSuccessAction("Leave plan added successfully");
            clearAddLeavPlanForm();
        })
        .catch(error=>{
            handleAxiosError(error);     
        });
    }
    return (
        // <div className="add-leave-plan-main-container">
        <Grid item xs={12} sm={12} md={12}>
            <Card>
                <MDBox
                    mx={2}
                    mt={-3}
                    py={1}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                >
                    <MDTypography variant="h6" color="white">
                        Add Leave Plan
                    </MDTypography>
                </MDBox>
                <MDBox component="form" mt={3} p={2} >
                    <Grid
                        container 
                        spacing={1}
                        className="add-leave-plan-form-grid-container"
                    >
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid item xs={3} sm={3} md={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Start Date"
                                        value={leavePlanStartDate}
                                        onChange={(newStartDate) => {
                                            setLeavePlanStartDate(newStartDate);
                                            // setFromDate(newStartDate);
                                        }}
                                        shouldDisableDate={disableWeekends} 
                                        renderInput={(params) => <TextField {...params} />}
                                        inputFormat={AppConstants.DATE_FORMAT_DISPLAY}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="End Date"
                                        value={leavePlanEndDate}
                                        onChange={(newEndDate) => {
                                            setLeavePlanEndDate(newEndDate);
                                            // setToDate(newEndDate);
                                        }}
                                        shouldDisableDate={disableWeekends} 
                                        renderInput={(params) => <TextField {...params} />}
                                        inputFormat={AppConstants.DATE_FORMAT_DISPLAY}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3}>
                                <TextField
                                    sx={{
                                        width: "400px"
                                    }}
                                    id="addLeavePlanDescription"
                                    label="Leave Plan Reason"
                                    placeholder="Leave Plan Reason"
                                    onChange={(descChangedEvent) => setLeavePlanReason(descChangedEvent.target.value)}
                                    multiline
                                    maxRows={2}
                                />
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControl>
                                    <FormLabel id="leave-duration-label" sx={{ fontSize: "13px", fontWeight: 700, "&.Mui-focused": { color: "#344767" } }}>Leave Duration</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby="leave-duration-label"
                                        name="leave-duration-group"
                                        value={isMultiDayLeave ? AppConstants.DEFAULT_LEAVE_DURATION : leaveDuration}
                                        onChange={(event) => setLeaveDuration(event.target.value)}
                                    >
                                        {AppConstants.LEAVE_DURATIONS.map((duration) => (
                                            <FormControlLabel
                                                key={duration.value}
                                                value={duration.value}
                                                control={<Radio />}
                                                label={duration.label}
                                                // Half-day options apply only to a single-day leave
                                                disabled={isMultiDayLeave && duration.value !== AppConstants.DEFAULT_LEAVE_DURATION}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            rowSpacing={2}
                            spacing={1}
                        >
                            <Grid item xs={3} sm={3} md={3}>
                                <Button
                                    onClick={addLeavePlanClickHandler}
                                    sx={{width:200, m: 0}}
                                    variant="contained" 
                                    color="success"
                                    endIcon={<AddCircleIcon id="add-leave-plan-for-member" fontSize="large" sx={{
                                            // fontSize: 40,
                                            palette: {
                                                primary: blue,
                                                secondary: green,
                                            },
                                        }} 
                                    />}
                                >
                                    Add Leave Plan
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Collapse in={open}>
                        <Alert
                        action={
                            <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                            >
                            <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        severity={severity}
                        sx={{ mb: 2 }}
                        >
                        {message}
                        </Alert>
                    </Collapse>
                </MDBox>
            </Card>
        </Grid>
    );
}